import React, { Component } from 'react'
import Widget from '../../shared/components/widget'
import Ads from '../../ads'
import SiteStat from '../../site-stat'
import BuySellShort from '../../buy-sell/short'

import "./styles.scss"

export default class extends Component {
  render() {
    const { t } = this.props
    return (
      <div className="row">
        <div className="col-md-12">
          <Widget title={t("policy_page_title")}>
            <div className="panel-content-row">
              <div
                dangerouslySetInnerHTML={{
                __html: t('policy_main_page_text')
                }} 
              />
              <div
                dangerouslySetInnerHTML={{
                __html: t('policy_main_page_text_two')
                }} 
              />
              <div
                dangerouslySetInnerHTML={{
                __html: t('policy_main_page_text_three')
                }} 
              />
            </div>
          </Widget>
        </div>
        <div className="col-md-4">
          <SiteStat />
          <BuySellShort />
          <Ads />
        </div>
      </div>
    )
  }
}
